import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { useDeleteTemplateMutation } from '@/core/services/report'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { getApiErrorMessage } from '@/utils/errors'
import { useSnackbar } from 'notistack'

type DeleteTemplateModalProps = {
  templateId: string
}

export default function DeleteTemplateModal({ templateId }: DeleteTemplateModalProps) {
  useLingui()
  const [deleteTemplateById] = useDeleteTemplateMutation()
  const [open, setOpen] = React.useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const handleDeleteTemplate = async () => {
    try {
      await deleteTemplateById(templateId).unwrap()
      setOpen(false)
    } catch (error: any) {
      enqueueSnackbar(getApiErrorMessage(error.message, t`An error occurred while deleting the template`), { variant: 'error', autoHideDuration: 3000 })
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <React.Fragment>
      <IconButton color="error" onClick={handleOpen} >
        <DeleteIcon />
      </IconButton>
      <Dialog open={open} onClose={handleClose} aria-labelledby="delete-template-dialog-title" aria-describedby="alert-delete-template">
        <DialogContent>
          <DialogContentText id="alert-delete-template">{t`This template will be permanently deleted`}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={handleClose}>{t`Cancel`}</Button>
          <Button variant="contained" onClick={handleDeleteTemplate}>{t`Agree`}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
